import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseApiUrl: string = environment.api.baseUrl;

  private authenticated: boolean = null;

  constructor(
    private http: HttpClient,
  ) {

  }

  isAuthenticated(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      if (this.authenticated === null) {
        this.http.get(this.baseApiUrl + 'check-me').pipe(shareReplay()).toPromise().then((data) => {
          if (data.hasOwnProperty('connected') && data['connected']) {
            this.authenticated = true;
            resolve(true);
          } else {
            this.authenticated = false;
            resolve(false);
          }

        }).catch(() => {
          this.authenticated = false;
          resolve(false);
        });
      } else {
        resolve(this.authenticated);
      }
    });
  }

  isParcoursTravauxRoute() {
    return window.location.pathname.startsWith('/parcours-travaux');
  }

  isParcoursTravauDetailxRoute() {
    return window.location.pathname.startsWith('/parcours-travaux/details/');
  }

  getAuthenticated() {
    return this.authenticated;
  }
}
